<div [class]="'offers-widget' + (inline ? ' inline' : '')">
  <h2>{{ title }}</h2>
  <app-offer class="offer-widget" [type]="type" [offer]="offer" *ngFor="let offer of offers"></app-offer>
  <div *ngIf="offers?.length === 0">
    <span>No packages found</span>
  </div>
</div>
